module.exports = __webpack_public_path__ + "img/jwhi.32fe2125.jpg";